var NexiChargeList_1;
import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiEnter from "@/api/ApiEnter";
import ApiNexiCharge from "@/api/ApiNexiCharge";
import DataNexiCharge from "@/data/NexiCharge/DataNexiCharge";
import { chargeErrorText, chargeStatusColor, chargeStatusText, errorMessage, formatAmount, formatDate } from "@/util/NexiCharge/NexiChargeDisplay";
import sweetalert from "sweetalert";
import dayjs from "dayjs";
let NexiChargeList = NexiChargeList_1 = class NexiChargeList extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataNexiCharge.Breadcrumbs;
        this.HasRequest = false;
        this.TableItems = [];
        this.search = "";
        this.HasDraft = false;
        this.ResendingUuid = null;
        this.menuDateFrom = false;
        this.menuDateTo = false;
        this.Filters = NexiChargeList_1.DefaultFilters();
        this.StatusFilterItems = [
            { text: this.$t("nexi_charge.status.ok"), value: "ok" },
            { text: this.$t("nexi_charge.status.error"), value: "error" },
        ];
        this.TableHeaders = [
            { text: this.$t("nexi_charge.table.subsid"), value: "subsid" },
            { text: this.$t("nexi_charge.table.order_product_id"), value: "order_product_id", width: "90px" },
            { text: this.$t("nexi_charge.table.order_id"), value: "order_id", width: "90px" },
            { text: this.$t("nexi_charge.table.customer"), value: "customer_name" },
            { text: this.$t("nexi_charge.table.amount"), value: "amount" },
            { text: this.$t("nexi_charge.table.contract"), value: "nexi_contract_id", cellClass: "text-no-wrap" },
            { text: this.$t("nexi_charge.table.status"), value: "status" },
            { text: this.$t("nexi_charge.table.esito"), value: "esito", width: "70px" },
            { text: this.$t("nexi_charge.table.email_sent"), value: "email_sent", align: "center", width: "90px" },
            { text: this.$t("nexi_charge.table.sent_at"), value: "sent_at", cellClass: "text-no-wrap" },
        ];
        this.ChargeStatusColor = chargeStatusColor;
        this.ChargeStatusText = chargeStatusText;
        this.ChargeErrorText = chargeErrorText;
        this.FormatAmount = formatAmount;
        this.FormatDate = formatDate;
    }
    // Filtro data di default: ultimi 30 giorni (coerente col default lato backend), prepopolato e visibile.
    static DefaultFilters() {
        return {
            status: "",
            date_from: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
            date_to: dayjs().format("YYYY-MM-DD"),
        };
    }
    async LoadCharges() {
        this.HasRequest = true;
        try {
            this.TableItems = await ApiNexiCharge.GetList(ApiEnter.CurrentSessionUUID, {
                status: this.Filters.status || undefined,
                date_from: this.Filters.date_from || undefined,
                date_to: this.Filters.date_to || undefined,
            });
        }
        catch (e) {
            sweetalert({
                title: this.$t("general.error"),
                text: errorMessage(e && e.code),
                icon: "error",
            });
        }
        this.HasRequest = false;
    }
    // Re-invio della mail al cliente per un addebito ok la cui mail non è partita.
    async OnResendEmail(item) {
        if (this.ResendingUuid) {
            return;
        }
        const confirmed = await sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("nexi_charge.confirm_resend_email"),
            icon: "warning",
            buttons: [this.$t("general.no"), this.$t("general.yes")],
        });
        if (!confirmed) {
            return;
        }
        this.ResendingUuid = item.charge_uuid;
        try {
            await ApiNexiCharge.ResendEmail(ApiEnter.CurrentSessionUUID, item.charge_uuid);
            item.email_sent = true;
            this.ResendingUuid = null;
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("nexi_charge.resend_email_success"),
                icon: "success",
            });
        }
        catch (e) {
            this.ResendingUuid = null;
            if (e && e.code === "nexi_email_already_sent") {
                item.email_sent = true;
            }
            sweetalert({
                title: this.$t("general.error"),
                text: errorMessage(e && e.code),
                icon: "error",
            });
        }
    }
    ResetFilters() {
        this.Filters = NexiChargeList_1.DefaultFilters();
        this.search = "";
        this.LoadCharges();
    }
    // Segnala se c'è una bozza in corso, per cambiare l'etichetta del pulsante di nuovo addebito.
    async LoadDraftFlag() {
        try {
            const draft = await ApiNexiCharge.GetDraft(ApiEnter.CurrentSessionUUID);
            this.HasDraft = Array.isArray(draft) && draft.length > 0;
        }
        catch (e) {
            this.HasDraft = false;
        }
    }
    mounted() {
        this.LoadCharges();
        this.LoadDraftFlag();
    }
};
NexiChargeList = NexiChargeList_1 = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], NexiChargeList);
export default NexiChargeList;
